import styled from '@emotion/styled'

import { palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  align-items: baseline;
  display: inline-flex;
`

export const StarsContainer = styled.div`
  position: relative;

  &:before {
    color: ${palette.goldenrod2};
    content: '\\2606\\2606\\2606\\2606\\2606';
  }
`

interface IProps {
  width: number
}

export const Fill = styled.div<IProps>`
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${props => props.width}%;

  &:after {
    color: ${palette.goldenrod2};
    content: '\\2605\\2605\\2605\\2605\\2605';
  }
`

export const StyledText = styled(Text)`
  margin-left: ${spacing.minorScale(1)}px;
`
